var help_center_search_ajax = null;
var search_keyword = '';
var prefilled_callus = false;
var help_center_ajax = null;
var email_checking_help_ajax = null;
var success_page_ajax = null;
var regex_email_pattern = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
var help_center_fields_md = null;
var help_center_fields_sm = null;
var details_entered = [];

jQuery("document").ready(function() {
    let help_center_page = '';

    changeFormsSizeAccordingToWidth();
    window.addEventListener("resize", changeFormsSizeAccordingToWidth);

    if ( checkContactRestricted() ){
        removeContactTopLinksAndReplace();
    }

    $(document).keydown(function(event) {
      if (event.keyCode == 27) {
       if ( $("#help-center-right-side").hasClass("open") ){
        $(".help-center-tint").click();
       }
      }
    });

    $(document).on("keyup",'.app-html .form-input-field[required]:visible', function() {

        var empty = false;
        $('.app-html .form-input-field[required]:visible').each(function() {
            if ($(this).val() == '') {
                empty = true;
            }
        });

        if (empty) {
            $('.help-center-contact-btn').attr('disabled', 'disabled');
        } else {
            if ( help_center_el === 'text-us' || regex_email_pattern.test($("#_elev_io #email_address").val()) !== false || $(".app-html .card-details").not(".d-none").length || $(".email-address-validation-message:visible:contains('reach you by phone')").length ){
                $('.help-center-contact-btn').removeAttr('disabled');
            }
        }

    });

    $(document).on("change",'.customer-field-value-changed', function () {
        var field_name = $(this).attr('name');
        var field_value = $(this).val();
        if (!field_value) {
            return;
        }
        if (field_name === 'customer_email') {
            jQuery("#talk-to-us-area #email_address").removeClass('non-verified');
            isvalidemail = regex_email_pattern.test(field_value);
            if (!isvalidemail) {
                $("#talk-to-us-area .email-address-validation-message").html('Please enter valid email address');
                $("#talk-to-us-area .email-address-validation-message").removeClass('danger').show();
                jQuery("#talk-to-us-area #email_address").addClass('danger');
                return;
            } else if (
                !didYouMeanEmail
                || (didYouMeanEmail && didYouMeanEmail !== jQuery('#email_address').val() && !keepWrittenEmail)
            ) {
                if ( !prefilled_callus ){
                    validateEmailFromAPI();
                }else{
                    email_flag = true;
                }
                return; // Save email only after verified
            }
        }

    });

  function validateEmailFromAPI() {

        var emailAddress = jQuery('#email_address').val();
        if (didYouMeanEmail && didYouMeanEmail === emailAddress) {
            return;
        }

        if ( typeof link_color === 'undefined' ){
            link_color = 'blue';
        }

        $("#talk-to-us-area .email-address-input").find(".loader").show();
        email_flag = false;
        email_checking_help_ajax = jQuery.ajax({
            type: "post",
            url: tm_ajax_url,
            dataType: "json",
            data: {
                "action": "validate_email_address",
                "email": emailAddress,
            },
            success(returnJSON) {

                var forceSave = true;
                if (returnJSON.data && returnJSON.data.did_you_mean) {
                    didYouMeanEmail = returnJSON.data.did_you_mean;

                    var suggestHTML = 'Did you mean <strong>' + didYouMeanEmail + '?</strong> <br />' + ' <a id="apply-did-u-mean-email" class="' + link_color + '" href="javascript:void(0)">Apply Change</a>';
                    if (returnJSON.data.smtp_check || returnJSON.data.mx_found) {
                        suggestHTML += ' or <a id="keep-written-email"  class="' + link_color + '"  href="javascript:void(0)">Keep Existing</a>';
                    }
                    jQuery("#talk-to-us-area .email-address-validation-message").html(suggestHTML);
                    jQuery("#talk-to-us-area .email-address-validation-message").removeClass('danger').show();
                    jQuery('#talk-to-us-area #email_address').addClass('danger');
                    jQuery('#talk-to-us-area #email_address').addClass('non-verified');
                    //jQuery(".help-center-contact-btn").attr("disabled", true);
                    jQuery(window.parent).scrollTop(0);
                    forceSave = false;
                    email_flag = false;
                }

                if ( forceSave ) {
                    // email confirmation line
                    updateEmailConfirmationLine(true);

                }

                $("#talk-to-us-area .email-address-input").find(".loader").hide();
            }
        })
    }

    jQuery('body').delegate('#apply-did-u-mean-email', 'click', function () {
        if (didYouMeanEmail) {
            jQuery('#email_address').val(didYouMeanEmail);
            jQuery('#email_address').trigger('change');
            updateEmailConfirmationLine();
        }
    });

    jQuery('body').delegate('#keep-written-email', 'click', function () {
        keepWrittenEmail = true;
        jQuery('#email_address').trigger('change');
        updateEmailConfirmationLine(true);
    });

    $(document).on('input', '#email_address', function () {
        keepWrittenEmail = false;
        updateEmailConfirmationLine();
    });

    $(document).on("keypress keydown keyup",'#_elev_io #form-first-name, #_elev_io #phone, #_elev_io #email_address', function () {
        if ( $("#_elev_io #booking-id-edit-btn").is(":visible") ){

            let tmPhoneElForHelpCenter = TmPhoneEl.instance(helpCenterPhoneIdentifier);
            let currentPhoneValue = tmPhoneElForHelpCenter.getNumber();
            if (
                $("#_elev_io #form-first-name").val() !== details_entered.name
                || currentPhoneValue !== details_entered.phone_number
                //|| $("#_elev_io #phone").val() !== details_entered.phone_number
                || $("#_elev_io #email_address").val() !== details_entered.email_address
            ){
                $("#form-booking-id").removeAttr("disabled").val('').addClass("empty");
                $(".help-center-contact-btn span").text("Lookup Booking");
                $(".booking-actions-el, .booking-id-not-found, .booking-id-found").addClass("hidden");
                $("#main-step-footer").show();
                $("#main-step-footer #request-callback-btn").show().attr("disabled","disabled");
                $("#main-step-footer #request-callback-btn .loader").hide();
                $("#cancellation-wrapper").empty();
                $("#_elev_io #booking-id-edit-btn").hide();
            }
        }
    });

    function updateEmailConfirmationLine(forceSuccess = false) {
        var emailVal = jQuery('#email_address').val();
        if (emailVal && regex_email_pattern.test(emailVal)) {
            if (
                (didYouMeanEmail && didYouMeanEmail === emailVal)
                || forceSuccess
            ) {

                if ( !prefilled_callus ){
                    jQuery("#talk-to-us-area .email-address-validation-message").html('If we can\'t reach you by phone we\'ll email <br /><strong style="color: green">' + emailVal + '</strong>');
                }else{
                    //jQuery("#talk-to-us-area .email-address-validation-message").html('');
                }

            } else {
                jQuery("#talk-to-us-area .email-address-validation-message").html('If we can\'t reach you by phone we\'ll email <br /><strong>' + emailVal + '</strong>');
            }
            prefilled_callus = false;
            email_flag = true;
            //jQuery(".help-center-contact-btn").attr("disabled", false);
            jQuery("#talk-to-us-area .email-address-validation-message").removeClass('danger').show();
            jQuery("#talk-to-us-area #email_address").removeClass('danger non-verified');
        } else {
            jQuery("#talk-to-us-area .email-address-validation-message").html('');
            //jQuery("#talk-to-us-area #email_address").addClass('danger');
        }

        $("#talk-to-us-area .message_field:visible").change();

    }

    $(document).on("click", ".help-center-link", function(e){
        e.preventDefault();
        let helpCenterLink = $(this);
        let openModuleAllow = true;

        if ( helpCenterLink.data("help-center") === 'manage-booking' ){
            openModuleAllow = true;
        }

        if ( helpCenterLink.data("help-center") === 'text-us' && tmVisitorStore.getDetail('name').length > 0 ) {
            openModuleAllow = false;
            textWhenWeHaveName();
        }

        if(helpCenterLink.data("help-center") === 'live-chat') {
            openModuleAllow = false;
            coolEvents.triggerChatOpen();
        }

        if ( openModuleAllow ){

            if ( typeof helpCenterLink.data("sidebar") === 'undefined' ){
                $("#load-wrapper").remove();
            }else{
                jQuery(".hc-faq__categories-title, [data-type='category'], [data-type='suggestions'], [data-type='search']").hide();
            }

            $("#help-center-right-side .loader").show();

            if ( typeof helpCenterLink.data("help-center") !== 'undefined' && $("#help-center-right-side").hasClass("open") ){

                var data = {
                    'action': 'help_center',
                    'h'     : 'open',
                    'o'     : helpCenterLink.data("help-center"),
                    'c'     : checkContactRestricted(),
                };

                if ( typeof helpCenterLink.data("accordion-expand") !== 'undefined' ){
                    data['a'] = '1';
                }

                help_center_ajax = jQuery.post(ajaxurl, data, function(response) {
                    help_center_page = 'categories';
                    if ( typeof helpCenterLink.data("sidebar") !== 'undefined' ){
                        $("#load-wrapper").remove();
                    }
                    $("#help-center-right-side").append( response );
                    $("#help-center-right-side .loader").hide();
                    $("#main-container").addClass("hideOnMobile");
                });

                changeFormsSizeAccordingToWidth();

            }else{

                if ( typeof helpCenterLink.data("accordion-expand") !== 'undefined' ){
                    $("#help-center-right-side").trigger("onHelpCenterInit", [helpCenterLink.data("help-center"), helpCenterLink.data("accordion-expand")]);
                }else{
                    $("#help-center-right-side").trigger("onHelpCenterInit", [helpCenterLink.data("help-center"), null ]);
                }
            }
        }


    });

    function textWhenWeHaveName(){
        if (tmVisitorStore.isSalesDepartment()) {
            sendText( "I'd like more info[PRODUCT/PAGE]", false );
        }
        else {
            sendText( "I have a question about my booking ", false );
        }
    }

    function sendText( txtBody = '', name = false ){
        txtBody = '[[BRAND]] ' + txtBody;
        if ( name ){
            txtBody = txtBody +  " [NAME]";
        }
        txtBody = fixShortCode( txtBody );

        const smsNumber = $(".sms_info a").data("sms").replace("(","").replace(")","").replace(" ","").replace("-","");
        window.open("sms:" + "+1" + smsNumber + "?&body=" + encodeURIComponent( txtBody ), '_self');
    }

    $("#help-center-right-side").on('onHelpCenterInit', function( event, type, accordion_expand ) {

        restartSearch();
        $(this).toggleClass("close");
        $(this).toggleClass("open");
        // $(this).toggleClass("open");
    $("#categories-section").show();
        if ( $(this).hasClass("close") && typeof help_center_ajax !== '' && typeof help_center_ajax !== 'undefined' && help_center_ajax !== null ){
            help_center_ajax.abort();
            //$("#help-center-right-side").children().remove();
            //$("section[data-view='categories']").remove();
        }else{
            $("#help-center-right-side .loader").show();
            $("#article-section").children().remove();
            jQuery(".hc-faq__categories-title, [data-type='category'] , [data-type='suggestions'], [data-type='search']").show();

            if ( true ){ // $(".helpCentreShell").length == 0
                var data = {
                    'action': 'help_center',
                    'h'     : 'open',
                    'c'     : checkContactRestricted(),
                };

                if ( typeof type !== 'undefined' ){
                    data.o = type;
                }

                if ( typeof accordion_expand !== 'undefined' ){
                    data.a = accordion_expand;
                }

                help_center_ajax = jQuery.post(ajaxurl, data, function(response) {
                    help_center_page = 'categories';
                    $("#help-center-right-side").append( response );
                    $("#help-center-right-side .loader").hide();
                    $("#main-container").addClass("hideOnMobile");
                    fixWidth();
                });
            }else{
                $("#help-center-right-side .loader").hide();
            }
        }
    });

   $(".mobile-help-link").on("click", evt => {
    evt.preventDefault();
    $("#help-center-right-side").trigger("onHelpCenterInit");
   });

    $(".c-avatar-dropdown-item-link.help-center-link").on("click", function(){
        $("#help-center-right-side").trigger("onHelpCenterInit");
    });

    jQuery(document).on("click", ".category-title", function(e){

        jQuery(this).next('.articles-list').toggleClass("hide");
        jQuery(this).find('.plus-minus-icon').toggleClass("hide");
        fixWidth();
    });

    jQuery(document).on("click", ".helpCentreShellMainInner .hClickable, .help-center-tint, .articles-list .help-center-link[data-help-center='live-chat']", function(e){
        restartSearch();
        $("#main-container").removeClass("hideOnMobile");
        $("#help-center-right-side .loader").hide();
        $("#help-center-right-side").toggleClass("close");
        $("#help-center-right-side").removeClass("open");
        $("#load-wrapper").remove();

        if ( typeof help_center_ajax !== '' && typeof help_center_ajax !== 'undefined' && help_center_ajax !== null ){
            help_center_ajax.abort();
        }

        if ( typeof email_checking_help_ajax !== '' && typeof email_checking_help_ajax !== 'undefined' && email_checking_help_ajax !== null ){
            email_checking_help_ajax.abort();
        }

        if ( typeof success_page_ajax !== '' && typeof success_page_ajax !== 'undefined' && success_page_ajax !== null ){
            success_page_ajax.abort();
        }

    });

    jQuery(document).on("click", ".hc-faq__back-button", function(){
        $("#article-section").children().remove();
        jQuery("#categories-section, .hc-faq__categories-title, [data-type='category'], [data-type='suggestions'], [data-type='search']").show();
        if ( $("#talk-to-us-area").length > 0 ){
            $("#talk-to-us-area").show();
            $("[data-slot-name='back_button']").show();
        }
        restartSearch();
    });

    jQuery(document).on("click", "._tm_articlelink_title", function(){

        if ( !$(this).hasClass("no-article") ){
            jQuery(".hc-faq__categories-title, [data-type='category'], [data-type='suggestions'], [data-type='search'], #talk-to-us-area, [data-slot-name='back_button']").hide();
            jQuery("#help-center-right-side .loader").show();

            var data = {
                'action': 'help_center',
                'h'     : 'article',
                'id'    : $(this).data("id"),
                'c'     : checkContactRestricted(),
            };

            help_center_ajax = jQuery.post(ajaxurl, data, function(response) {
                help_center_page = 'article';
                jQuery("#help-center-right-side .loader").hide();
                $("#article-section").children().remove();
                $("#article-section").append( response );
            });
        }
    });

    jQuery(document).on("click", "._tm_close_search_icon_container", function(){
        restartSearch();
    });


    jQuery(document).on("keyup", "#_tm_io_placebo",  function(e) {
        const text_input = $(this);

        $("._tm_search_results").hide();
        $(".search_results_loader").hide();

        if ( help_center_search_ajax !== null ){
            help_center_search_ajax.abort();
        }

        if ( $(text_input).val().length > 0 ){
            $("._tm_search_results").show();
            $("._tm_close_search_icon_container").show();
            $("#search-for").text( '"' + $(text_input).val() + '"' )
        }else{
            $("._tm_close_search_icon_container").hide();
        }

        if ( search_keyword != $(text_input).val() ){
            $("._tm_search_results_content").css("opacity",0);
            $("#_tmn_io ._1dafq").css("opacity",1);
        }

        if ( $(text_input).val().length > 1  && e.which === 13 ){ // If enter pressed
            $(".search_results_loader").show();
            $("#_tmn_io ._1dafq, ._tm_search_results_content").css("opacity","0");

            var data = {
                'action': 'help_center',
                'h'     : 'search-article',
                's'     : $(text_input).val(),
                'c'     : checkContactRestricted(),
            };

            help_center_search_ajax = jQuery.post(ajaxurl, data, function(response) {
                search_keyword = $(text_input).val();
                $("._tm_search_results_content").remove();
                $("._tm_search_results").append(response);
                $("._tm_search_results_content").css("opacity","1");
                $(".search_results_loader").hide();

            });
        }
    });

    $(document).on("click",".removeLink", function(e){
        e.preventDefault();
    });

    $(document).on("click","#request-callback-btn, #live-chat-btn:contains('Lookup Booking'), #live-chat-btn:contains('Request a Callback')", function(){
        const callback_btn = $(this);

        const name = $("#_elev_io #form-first-name").val();
        let tmPhoneElForHelpCenter = TmPhoneEl.instance(helpCenterPhoneIdentifier);
        const phone = tmPhoneElForHelpCenter.getNumber();
        //const phone = $("#_elev_io #phone").val();
        const email = $("#_elev_io #email_address").val();

        if ( typeof success_page_ajax !== '' && typeof success_page_ajax !== 'undefined' && success_page_ajax !== null ){
            success_page_ajax.abort();
        }

        callback_btn.attr("disabled", true);
        callback_btn.find(".loader").removeClass("hidden").css("display","inline");

        if ( jQuery.trim($(this).text()) === 'Start Cancellation' && $("#booking_actions").val() == 3 ){

            $("#booking_actions").prop("disabled",true);
            var data = {
                'action': 'help_center_cancellation_request_callback',
                'first': name,
                'email': email,
                'phone': phone,
                'booking_id': $("#form-booking-id").val(),
                'l'     :  tmUtils.getAjaxRequestNonce(),
            }


            success_page_ajax = jQuery.post(ajaxurl, data, function(response) {
                try {
                    coolEvents.visitorProvidedDetails(name, email, phone);
                }
                catch(error) {}

                $("#main-step-footer").hide();
                $("#cancellation-wrapper").append(response);
                $("#booking_actions").prop("disabled",false);

                if ( !$("#terms-of-use").length ){
                    var data = {
                        'action': 'help_center_js_modal_page_callback',
                        'f'    : 'popup-tou',
                        'i'    : 'terms-of-use',
                        'l'     :  tmUtils.getAjaxRequestNonce(),
                    }


                    jQuery.post(ajaxurl, data, function(response) {
                        $(response).insertAfter('.help-center-tint');
                    });
                }

                if ( !$("#privacy-policy").length ){
                    var data = {
                        'action': 'help_center_js_modal_page_callback',
                        'f'    : 'popup-privacy-policy',
                        'i'    : 'privacy-policy',
                        'l'     :  tmUtils.getAjaxRequestNonce(),
                    }


                    jQuery.post(ajaxurl, data, function(response) {
                        $(response).insertAfter('.help-center-tint');
                    });
                }

            });
            return false;
        }

        var message = $("#_elev_io .message_field:visible").val();
        const department_id = $("#_elev_io #how_can_we_help option:selected").data('id');
        var selectedType = $('#how_can_we_help option:selected').attr('data-calltype');
        var callType = $('#how_can_we_help').val();

        if ( selectedType === 'ExistingBooking' && $(".help-center-contact-btn span").text() === 'Request a Callback' ){
            selectedType = 'Support';
            callType = 'Assistance with an existing booking';
        }

        var data = {
            'action': 'help_center_request_callback',
            'calltype': selectedType,
            'calltype_description': callType,
            'first': name,
            'email': email,
            'phone': phone,
            'message': message,
            'l'     :  tmUtils.getAjaxRequestNonce(),
            'm'     :  JSON.stringify(tmVisitorStore.getTags())
        };

        if ( $('#how_can_we_help option:selected').attr('data-calltype') === 'ExistingBooking' && $(".help-center-contact-btn span").text() === 'Request a Callback' ){
            data.booking_id = $("#form-booking-id").val();
            data.booking_action = $("#booking_actions option:selected").text();
        }

        if ( typeof a_id !== 'undefined' ){
            data.a_id = a_id;
        }

        if ( $(".step-footer button span").text() !== 'Lookup Booking' ){
            success_page_ajax = jQuery.post(ajaxurl, data, function(response) {
                try {
                    coolEvents.visitorProvidedDetails(name, email, phone);
                }
                catch(error) {}

                if ( response.search("Sorry") === -1 ){
                    //setZopimDataForChat( name, phone, email, message, department_id, false, false );
                    //Cookies.set("tm-contact-restricted", "true", { expires: 1 });
                    //removeContactTopLinksAndReplace();
                }

                $("#page-1").remove();
                $("#page-2").append(response);
                $("#page-2").removeClass("hidden");
            });
        }
        else {
            tmVisitorStore.saveDetails(name, phone, email);
        }

        if ( $(".step-footer button span").text() === 'Lookup Booking' ){
            data.booking_id = $("#form-booking-id").val();
            data.action = "help_center_check_booking_callback";

            $(".booking-id-found, .booking-id-not-found").addClass("hidden");


            success_page_ajax = jQuery.post(ajaxurl, data, function(response) {
                $("#form-booking-id").attr("disabled","disabled");
                $(".message-request-element").addClass("hidden");

                const resp = JSON.parse( response );

                if ( resp.error == 1  ){ // order not found, cancelled etc
                    if ( resp.error_message == 'Order is old' ){
                        $(".booking-actions-el").removeClass("hidden");
                        $("#booking_actions .extra-option-my-booking").remove();
                        $("#booking_actions .first-select-an-option").after( resp.options );
                    }else{
                        $(".booking-id-found").removeClass("hidden");
                        callback_btn.hide();
                    }

                    if ( resp.request_box ){
                        callback_btn.show();
                        callback_btn.attr("disabled", true);
                        callback_btn.find(".loader").hide();
                        $(".booking-id-not-found > p").html( resp.request_box_message );
                        $(".step-footer button span").text("Request a Callback");
                        $(".booking-id-not-found").removeClass("hidden");
                    }

                }else{ // order found
                    $(".booking-id-found, .booking-actions-el").removeClass("hidden");
                    $("#booking_actions .extra-option-my-booking").remove();
                    $("#booking_actions .first-select-an-option").after( resp.options );
                    $(".help-center-contact-btn").removeAttr("disabled");
                    callback_btn.hide();
                }

                $("#booking-id-edit-btn").show();
            });

            details_entered.name = $("#_elev_io #form-first-name").val();
            let tmPhoneElForHelpCenter = TmPhoneEl.instance(helpCenterPhoneIdentifier);
            details_entered.phone_number = tmPhoneElForHelpCenter.getNumber();
            //details_entered.phone_number = $("#_elev_io #phone").val();
            details_entered.email_address = $("#_elev_io #email_address").val();

            $("#booking_actions").val("");
            $("#_elev_io .message_field:visible").val('').addClass("empty");
        }

    });

    $(document).on("click", "#booking-id-edit-btn", function(){
        $("#form-booking-id").removeAttr("disabled").val('').addClass("empty").focus();
        $(".help-center-contact-btn span").text("Lookup Booking");
        $(".booking-actions-el, .booking-id-not-found, .booking-id-found").addClass("hidden");
        $("#main-step-footer").show();
        $("#main-step-footer #request-callback-btn").show().attr("disabled","disabled");
        $("#main-step-footer #request-callback-btn .loader").hide();
        $("#cancellation-wrapper").empty();
        $(this).hide();
    });

    $(document).on("click", "#send-text-btn", function(){
        if ( typeof success_page_ajax !== '' && typeof success_page_ajax !== 'undefined' && success_page_ajax !== null ){
            success_page_ajax.abort();
        }

        var sendTextButton = $(this);

        sendTextButton.attr("disabled", true);
        sendTextButton.find(".loader").removeClass("hidden").css("display","inline");

        var data = {
            'action': 'help_center_text_us_callback',
        };

        success_page_ajax = jQuery.post(ajaxurl, data, function(response) {
            const name = $("#_elev_io #form-first-name").val();
            let department_type = $("#_elev_io #how_can_we_help option:selected").data('calltype');
            tmVisitorStore.saveDetails(name);
            sendText( $(".message_field:visible").val(), true );
            $("#page-1").remove();
            $("#page-2").append(response);
            $("#page-2").removeClass("hidden");
        });
    })

    $(document).on("focus blur", "#_elev_io #form-first-name", function(e){
        if ( help_center_el === 'text-us' ){
            $("#how_can_we_help").trigger("change");
        }
    });

    $(document).on("click", ".customer-change", function(){
        jQuery(".card-details").toggleClass("d-none");
        jQuery(".change-inputs .d-none").toggleClass("d-none");
        jQuery('#form-first-name').focus();
    })

    $(document).on("click", "#request-a-refund-btn", function(){
        const callback_btn = $(this);
        callback_btn.attr("disabled", true);
        callback_btn.find(".loader").removeClass("hidden").css("display","inline");

        const name = $("#_elev_io #form-first-name").val();
        let tmPhoneElForHelpCenter = TmPhoneEl.instance(helpCenterPhoneIdentifier);
        const phone = tmPhoneElForHelpCenter.getNumber();
        //const phone = $("#_elev_io #phone").val();
        const email = $("#_elev_io #email_address").val();

        var data = {
            'action': 'help_center_refund_request_callback',
            'first': name,
            'email': email,
            'phone': phone,
            'booking_id': $("#form-booking-id").val(),
            'l'     :  tmUtils.getAjaxRequestNonce(),
        };

        jQuery.post(ajaxurl, data, function(response) {
            $("#help-center-right-side").removeClass("open").addClass("close");
            window.open(response, "_blank");
        });
    });

    $(document).on("change","#booking_actions", function(){
        $("#cancellation-wrapper").children().remove();
        $("#main-step-footer").show();
        $(".help-center-contact-btn").attr("disabled","disabled").end().find(".loader").hide();
        if ( $(this).val().length > 0 ){
            $('.help-center-contact-btn').show().end().removeAttr('disabled').end().find(".loader").hide();
            if ( $(this).val() === "5" ){
                $(".message-request-element").addClass("hidden");
                $(".help-center-contact-btn").prop("id","request-a-refund-btn");
                $(".help-center-contact-btn").removeAttr("disabled");
                $('.help-center-contact-btn span').text("Request a Refund");
            }else if ( $(this).val() === "3" ){
                $(".message-request-element").addClass("hidden");
                $(".help-center-contact-btn").removeAttr("disabled");
                $(".help-center-contact-btn").prop("id","request-callback-btn");
                $('.help-center-contact-btn span').text("Start Cancellation");
            }else{
                $(".message-request-element").removeClass("hidden");
                $(".help-center-contact-btn").prop("id","request-callback-btn");
                $('.help-center-contact-btn span').text("Request a Callback");
            }
        }
    });

    $(document).on("change", "#how_can_we_help", function() {
        $("#your-details .card-details").removeClass("booking_margin");

        if ( $(this).val() === 'Support (I have a booking)' ){
            $("#your-details .card-details").addClass("booking_margin");
            $("#your-details #your-details-description").show();
        }
        else {
            $("#your-details #your-details-description").hide();
        }

        if ( $(this).val() !== '' ){
            $("#main-step-footer").show();
            //$("#request-callback-btn span").text( help_center_contact_button_text );

            $("#your-details").removeClass("hidden");

            const option = $(this).find("option:selected").data("option");
            const footer_message = $(this).find("option:selected").data("footer-message");

            if ( option === 'option-1-4' ){
                $(".help-center-contact-btn span").text("Lookup Booking");
            }

            $(".step-footer-message, .step-footer-message li").addClass("hidden");

            if ( footer_message ) {
                $(".step-footer-message").removeClass("hidden");
                $(".step-footer-message li").each( function ( element ){
                    let liClasses = $(this).prop("class").replace("hidden ","").split(" ");
                    if ( liClasses.includes( option ) ){
                        $(this).removeClass("hidden");
                    }
                });
            }

            $(".div-element").addClass("hidden");
            $(".div-element").each( function ( element ){
                let divClasses = $(this).prop("class").replace("hidden ","").replace("col-12 ","").replace("div-element ","").split(" ");
                if ( divClasses.includes( option ) ){
                    $(this).removeClass("hidden");
                }
            });


        }else{
            $("#your-details").addClass("hidden");
            $("#main-step-footer").hide();
        }

        $("#_elev_io .step-footer button span").text( $(this).find("option:selected").data("button-label")  );

        if ( $(this).val() === 'Support (I have a booking)' ){
            $("#your-booking-area").removeClass("hidden");
        }else{
            $("#your-booking-area").addClass("hidden");
        }

        fieldsCheck();

        if ( help_center_el === 'text-us' ){
            let fixedShortCodeMessage = fixShortCode( $(this).find("option:selected").data("text-us-message") ?? '' );
            $(".message_field:visible").val( fixedShortCodeMessage ).trigger("change");
        }
    })

    function fieldsCheck(){
        $(".app-html .form-input-field[required]:visible").keyup();
    }

});

function mainPage(){
    $(".categories-outer").children().remove();
    $("#help-center-right-side .loader").show();

    var data = {
        'action': 'help_center',
        'h'     : 'open',
        'a'     : '1',
        'c'     : checkContactRestricted(),
    };

    help_center_ajax = jQuery.post(ajaxurl, data, function(response) {
        help_center_page = 'categories';
        $("#load-wrapper").remove();
        $("#help-center-right-side").append( response );
        $("#help-center-right-side .loader").hide();
        $("#main-container").addClass("hideOnMobile");

    });
}

function changeFormsSizeAccordingToWidth(){

    const fields = $("#_elev_io .custom-input:not(.fixed-input-style), #_elev_io .custom-select:not(.fixed-input-style)");

    if ( fields.length > 0 ){
        if ( document.documentElement.clientWidth > 700 ){
            fields.removeClass("custom-input-sm");
            fields.addClass("custom-input-md");
        }else{
            fields.removeClass("custom-input-md");
            fields.addClass("custom-input-sm");
        }
    }
}

var helpCenterPhoneIdentifier = 'helpCenterPhone';
var helpCenterPhoneIdentifierInc = 1;
function HelpCenterInit(){
    helpCenterPhoneIdentifier = 'helpCenterPhone' + '__' + helpCenterPhoneIdentifierInc;
    helpCenterPhoneIdentifierInc ++;
    fixWidth();
    pageLoad();

    TmPhoneEl.add(document.querySelector('#phone'), helpCenterPhoneIdentifier);
    changeFormsSizeAccordingToWidth();

    setTimeout( function(){
        setVisitorContact();
        $("#how_can_we_help").change();
    }, 200);

    if ( typeof link_color != 'undefined' ){
            jQuery("._elevio_article_body a").addClass(link_color);
    }
}

function setVisitorContact(){
    let visitorInfo = {};
    visitorInfo.full_name = tmVisitorStore.getDetail('name');
    if( visitorInfo.full_name ) {
        visitorInfo.first_name = visitorInfo.full_name.split(" ")[0];
        visitorInfo.last_name = visitorInfo.full_name.split(" ")[1];
        let visitorPhone = tmVisitorStore.getDetail('phone');
        let visitorEmail = tmVisitorStore.getDetail('email');

        if ( visitorPhone ){
            visitorInfo.country_code = visitorPhone.split("(")[0].replace("+","")
            visitorInfo.phone = visitorPhone.split("(")[1];
            if ( visitorPhone.split("(")[1] !== undefined ){
                visitorInfo.phone = visitorInfo.phone.replace(")","").replace("-","").replace(" ","");
            }else{
                visitorInfo.phone = visitorPhone;
            }
            visitorInfo.full_phone = visitorPhone.replace(")","").replace("-","").replace("(","");
            jQuery("span[data-ref='phone']").text( visitorInfo.full_phone );

            let tmPhoneElForHelpCenter = TmPhoneEl.instance(helpCenterPhoneIdentifier);
            tmPhoneElForHelpCenter.setNumber(visitorInfo.full_phone);
        }

        if (  visitorEmail ){
            visitorInfo.email = visitorEmail;
        }

        if ( visitorInfo.first_name !== 'Visitor' ){
            $(".app-html #form-first-name").val(visitorInfo.full_name);
            jQuery("span[data-ref='name']").text( visitorInfo.full_name );
        }

        $(".app-html #form-first-name").trigger("change");

        if ( visitorInfo.email ){
            $(".app-html #email_address").val(visitorInfo.email);
            jQuery("span[data-ref='email']").text( visitorInfo.email );
            prefilled_callus = true;
            $(".app-html #email_address").trigger("change");
        }
    }

    const name = $(".app-html #form-first-name").val();
    const phone = $(".app-html #phone").val();
    const email = $(".app-html #email_address").val();

    if ( name.length === 0 || phone.length === 0 || email.length === 0 ){
        jQuery(".card-details").toggleClass("d-none");
        jQuery(".change-inputs .d-none").toggleClass("d-none");
        jQuery('#form-first-name').focus();
    }

    let latestOrderRef = tmVisitorStore.getLatestOrderRef();
    let currentVisitorDepartment = 'Sales'
    if ( latestOrderRef !== null ){
        currentVisitorDepartment = 'Support';
        $("#form-booking-id").removeAttr("disabled").val(latestOrderRef).removeClass("empty");
    }
    $("#how_can_we_help").find("option[data-calltype=" + currentVisitorDepartment + "]").prop("selected","selected").change();

}

function checkContactRestricted(){
    return typeof Cookies.get('tm-contact-restricted') !== 'undefined' ? true : false;
}

function removeContactTopLinksAndReplace(){
    $("li.sms_info ,li.sms_info + li").remove();
    $(".contact_info .underline-hover").text('We will reach out to you soon.');
    $(".contact_info .underline-hover").parent().addClass("removeLink");
    $(".contact_info a").removeClass("help-center-link");

    if ( $(".talk-to-us-area").length > 0 ){
        $(".talk-to-us-area a").removeClass("help-center-link").addClass("removeLink").text('We received your callback request and will reach out soon (support hours 8am-11pm EST).');
    }

    if ( $(".text-message-area").length > 0 ){
        $(".text-message-area").remove();
    }

    if ( $(".live-chat-area").length > 0 ){
        $(".live-chat-area").remove();
    }

    if ( $(".here-to-help-section").length > 0 ){
        var str = $('.here-to-help-section p').html().replace(/We’re here to help. /g, '');
        $('.here-to-help-section p').html(str);

        $(".here-to-help-section em").text('We have received your callback request and will reach out soon (support hours 8am-11pm EST).');
    }
}
